<template>
  <v-app>
    <v-main>
      <v-container class="" fluid>
        <v-row class="mt-5" justify="center">
          <v-col cols="12" xs="3" sm="7" md="6" lg="4" xl="3" class="mt-5">
            <LoginLogo />
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" xs="12" sm="12" md="9" lg="6" xl="5">
            <FormLogin />
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" xs="12" sm="12" md="12">
            <SocialMedia />
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import FormLogin from '@/components/login/FormLogin.vue'
import Footer from '@/components/login/Footer.vue'
import SocialMedia from '@/components/social/SocialMedia.vue'
import LoginLogo from '@/components/logo/LoginLogo.vue'

export default {
  name: 'Login',
  components: {
    FormLogin,
    SocialMedia,
    LoginLogo,
    Footer,
  },
}
</script>
